<template>
<div class="section">
  <div class="container has-max-width">
    <h1 class="title is-1 has-text-weight-bold">
      <span class="icon is-large space-right">
        <img src="@/assets/munchybit-logo.png" alt="Munchybit logo">
      </span>
      <span>MunchyBit Trivia</span>
    </h1>
    <div v-if="!ready || isBusy">
      <span class="icon is-large has-text-primary">
        <i class="fas fa-3x fa-spinner fa-spin"></i>
      </span>
    </div>
    <div v-else>
      <div v-if="dbUser" class="space-bottom-big has-text-weight-medium">
        Welcome back, {{dbUser.data.nickName}}!
      </div>
      <b-field v-else label="Your Nickname" custom-class="is-large">
        <b-input v-model="nickName"
          @keyup.enter.exact.native="startClicked"
          maxlength="15"
          size="is-large"></b-input>
      </b-field>
      <div class="buttons">
        <button v-if="dbUser && dbUser.data.inGame" @click="backToGame" class="button is-large is-info">
          <span>Back to Game</span>
          <span class="icon">
            <i class="fas fa-arrow-circle-right"></i>
          </span>
        </button>
        <button @click="startClicked" class="button is-large is-primary">
          <span>Create New Game</span>
          <span class="icon">
            <i class="fas fa-arrow-circle-right"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'ub-home',
  props: [],
  data() {
    return {
      nickName: null,
      isBusy: false,
    };
  },
  computed: {
    ready() {
      return this.$store.getters['user/ready'];
    },
    dbUser() {
      return this.$store.getters['user/dbUser'];
    },
  },
  methods: {
    backToGame() {
      this.gotoLobby(this.dbUser.data.inGame);
    },
    gotoLobby(gameId) {
      this.$router.push({
        name: 'ub-lobby',
        params: {
          gameId,
        },
      });
    },
    createGame() {
      //* create a trivia then go to the lobby
      return this.$store.dispatch('trivia/create', {
        type: 'trivia',
        name: this.dbUser.data.nickName,
      }).then((gameId) => {
        this.isBusy = false;
        this.gotoLobby(gameId);
      }).catch((err) => {
        this.isBusy = false;
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Failed to save user',
        });
        console.error(err);
        throw err;
      });
    },
    startClicked() {
      if (this.dbUser) {
        this.createGame();
        return;
      }
      if (!this.nickName) {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Please enter a nickname',
        });
        return;
      }
      if (this.isBusy) return;
      this.isBusy = true;
      this.$store.dispatch('user/create', {
        nickName: this.nickName,
        img: '',
      }).then(() => {
        return this.createGame();
      })
      .catch((err) => {
        this.isBusy = false;
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Failed to save user',
        });
        console.error(err);
        throw err;
      });
    },
    // initialize() {
    //   firebase.auth().signInAnonymously().catch((error) => {
    //     console.error(error)
    //   });
    // }
  },
  mounted() {
    //* this is where we log anonymous user
    // this.initialize();
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>

</style>

